
export default "/assets/newspaper-micro.86e5e666.svg"